import React from 'react';
import Img from "../../images/services/cto/custom.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2>Dedicated CTO Services For Businesses</h2>
                        <p>Whether you are a startup or a large-scale production facility planning to opt for digital
                            transformation initiatives, TekRevol’s CTO services will provide you the right consultancy
                            for your business.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;